import React from 'react'
import styles from './vacancyPriorityLabel.module.scss'
import cn from 'classnames'

const VacancyPriorityLabel = ({ label, urgent }) => {
  return <label className={cn(styles.label, { [styles.urgentLabel]: urgent })}>{label}</label>
}

export default VacancyPriorityLabel
